import { Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute } from '@angular/router';
import { Organizations } from '@app/interface/organizations';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SavedproductAutocompleteComponent } from '@app/savedproduct-autocomplete/savedproduct-autocomplete.component';
import { ToastService } from '@app/services/toast.service';

export interface GuideDialogData {
  organizationId: number;
  organization: Organizations;
}

@Component({
  selector: 'izy-guide-1-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  templateUrl: './guide-1-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide1DetailsDialogComponent {
  private toast = inject(ToastService);
  guideForm: FormGroup;
  organizationId: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide1DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
    }
  }

  goToNewInvoice(): void {
    this.router.navigate([`/${this.organizationId}/new_invoice`]);
    this.dialogRef.close(false);
  }

  goToNewCompany(): void {
    this.router.navigate([`/${this.organizationId}/new_company`]);
    this.dialogRef.close(false);
  }

  goToUploadXML(): void {
    this.router.navigate([`/${this.organizationId}/upload_xml`]);
    this.dialogRef.close(false);
  }

  goToDashboard(): void {
    this.router.navigate([`/${this.organizationId}/dashboard`]);
    this.dialogRef.close(false);
  }
}

@Component({
  selector: 'izy-guide-2-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  templateUrl: './guide-2-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide2DetailsDialogComponent {
  guideForm: FormGroup;
  organizationId: number = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide2DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
    }
  }

  public sourceLabels: Record<string, string> = {
    BEIZY: 'Beizy',
    'CAF UIL Toscana': 'CAF UIL Toscana',
    OTHER: 'fatturazione',
  };

  goToNewInvoice(): void {
    this.router.navigate([`/${this.organizationId}/new_invoice`]);
    this.dialogRef.close(false);
  }
}

@Component({
  selector: 'izy-guide-3-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SavedproductAutocompleteComponent,
  ],
  templateUrl: './guide-3-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide3DetailsDialogComponent {
  guideForm: FormGroup;
  organizationId: number = 0;

  productControl = new FormControl('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide3DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
    }
  }

  public sourceLabels: Record<string, string> = {
    BEIZY: 'Beizy',
    'CAF UIL Toscana': 'CAF UIL Toscana',
    OTHER: 'fatturazione',
  };

  goToCompanyTable(): void {
    this.router.navigate([`/${this.organizationId}/company_table`]);
    this.dialogRef.close(false);
  }

  goToProductTable(): void {
    this.router.navigate([`/${this.organizationId}/savedproducts_table`]);
    this.dialogRef.close(false);
  }
}

@Component({
  selector: 'izy-guide-4-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SavedproductAutocompleteComponent,
  ],
  templateUrl: './guide-4-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide4DetailsDialogComponent {
  guideForm: FormGroup;
  organizationId: number = 0;

  productControl = new FormControl('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide4DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
    }
  }

  public sourceLabels: Record<string, string> = {
    BEIZY: 'Beizy',
    'CAF UIL Toscana': 'CAF UIL Toscana',
    OTHER: 'fatturazione',
  };

  goToInvoiceTable(): void {
    this.router.navigate([`/${this.organizationId}/invoices_table`]);
    this.dialogRef.close(false);
  }
}

@Component({
  selector: 'izy-guide-5-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SavedproductAutocompleteComponent,
  ],
  templateUrl: './guide-5-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide5DetailsDialogComponent {
  guideForm: FormGroup;
  organizationId: number = 0;

  productControl = new FormControl('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide5DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
    }
  }

  public sourceLabels: Record<string, string> = {
    BEIZY: 'Beizy',
    'CAF UIL Toscana': 'CAF UIL Toscana',
    INVOICING: 'Beizy',
    OTHER: 'fatturazione',
  };

  goToFiscalPlan(): void {
    this.router.navigate([`/${this.organizationId}/fiscal_plan`]);
    this.dialogRef.close(false);
  }

  goToDichiarazione(): void {
    this.router.navigate([`/${this.organizationId}/dichiarazione`]);
    this.dialogRef.close(false);
  }
}

@Component({
  selector: 'izy-guide-6-details-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SavedproductAutocompleteComponent,
  ],
  templateUrl: './guide-6-details-dialog.component.html',
  styleUrl: './guide-details-dialog.component.scss',
})
export class Guide6DetailsDialogComponent {
  private toast = inject(ToastService);
  guideForm: FormGroup;
  organizationId: number = 0;

  helpEmail: string = 'info@forfettari-online.it';
  helpNumber: string = '800 950 206';

  productControl = new FormControl('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<Guide6DetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GuideDialogData,
  ) {
    this.guideForm = new FormGroup({
      organization_id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.organization) {
      this.guideForm.patchValue({
        organization_id: this.data.organization.id,
      });
    }

    if (this.data.organization) {
      this.organizationId = this.data.organization.id;
      this.helpEmail = this.data.organization.help_email;
      this.helpNumber = this.data.organization.help_number;
    }
  }

  public sourceLabels: Record<string, string> = {
    BEIZY: 'Beizy',
    'CAF UIL Toscana': 'CAF UIL Toscana',
    OTHER: 'fatturazione',
  };

  goToProfile(): void {
    this.router.navigate([`/${this.organizationId}/profile`]);
    this.dialogRef.close(false);
  }

  goToDocuments(): void {
    this.router.navigate([`/${this.organizationId}/documents_table`]);
    this.dialogRef.close(false);
  }

  goToMessages(): void {
    this.router.navigate([`/${this.organizationId}/inbox`]);
    this.dialogRef.close(false);
  }

  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.helpEmail)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(false); // Close with success
        this.showSuccessMessage('Indirizzo mail copiato negli appunti.');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  copyNumberToClipboard(): void {
    navigator.clipboard
      .writeText(this.helpNumber)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(false); // Close with success
        this.showSuccessMessage('Numero copiato negli appunti.');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }
}
